import { useQueryClient } from '@tanstack/react-query';
import {
	form602SubmissionQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';

interface Form602SubmissionQuery {
	formularPodaniId: string;
}

export const useForm602SubmissionQuery = ({
	formularPodaniId,
}: Form602SubmissionQuery) => {
	const queryClient = useQueryClient();
	const queryKey = ['form602-submission', formularPodaniId];
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery(
		{
			queryKey,
			queryFn: () => form602SubmissionQuery(axiosInstance, formularPodaniId),
		},
		{ errorIgnoreFilter: () => true }
	);

	return {
		data: query.data,
		isLoading: query.isLoading,
		error: query.error,
		isNotFoundError: query.error?.response?.status === 404,
		queryKey,
		invalidateQuery: async () => await queryClient.invalidateQueries(queryKey),
	};
};
